// is object a date?
export function isDate(d) {
  return Object.prototype.toString.call(d) === '[object Date]';
}
export function parseDate(str) {
  if (str === null || isDate(str)) return str || null;
  const p = str.match(/^(\d{1,2})\/?(\d{1,2})?\/?(\d{2,4})?$/);
  if (!p) return null;
  return new Date(
    parseInt(p[3] || new Date().getFullYear()),
    parseInt(p[2] || new Date().getMonth() + 1) - 1,
    parseInt(p[1]),
    0,
    0,
    0,
    0
  );
}

// super simple pt-BR date format
export function formatDate(m, y) {
  const d = new Date(y, m + 1, 0);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [year, month, day].join('-');
}

export function flatten() {
  return this.reduce(function(prev, cur) {
    const more = [].concat(cur).some(Array.isArray);
    return prev.concat(more ? cur.flatten() : cur);
  }, []);
}

export function removeDuplicates(arr) {
  return arr.filter((item, index) => arr.indexOf(item) >= index);
}

export function arrDupes(myArr, prop) {
  return myArr.filter(
    (obj, pos, arr) =>
      arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos
  );
}

export const sessionCookies = {
  set: (name, value) => {
    const maxAge = 24 * 60 * 60; // 1 day = 24h * 60m * 60s
    document.cookie = `${name}=${value}; path=/; max-age=${maxAge}; samesite=strict; secure`;
  },
  get: name => {
    const cookieData = document.cookie.split('; ').find(row => row.startsWith(`${name}=`));
    if (!cookieData) { return; }
    return cookieData.split('=')[1];
  },
  remove: name => {
    document.cookie = `${name}=; path=/; max-age=-1; samesite=strict; secure`;
  }
};

export const checkToken = () => sessionCookies.get("token") && sessionCookies.get("token") === localStorage.getItem("token");

export function authHeader() {
  // return authorization header with jwt token
  const user = checkToken() && JSON.parse(localStorage.getItem('user'));

  if (user && user.token) {
    return { Authorization: `Bearer ${user.token}` };
  }
  return {};
}
